import { Button } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const PersonalAreaButton = () => {
  const isDesktop = useIsDesktop();
  return (
    <Button
      sx={{
        bgcolor: '#1552E8',
        color: 'white',
        borderRadius: '12px',
        padding: isDesktop ? '12px' : '10px',
        height: '46px',
        width: '111px',
        fontSize: isDesktop ? '18px' : '16px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        ':hover': {
          bgcolor: '#4213d1',
        },
        ':focus': {
          border: '1px solid white',
        },
      }}
      onClick={() => {
        window.location.href = '/';
      }}
    >
      {Dictionary[DICTIONARY.Header].toPrivateArea}
    </Button>
  );
};
